<p-dialog [(visible)]="display" [styleClass]="'groundModal'" [appendTo]="'body'"
          [header]="'GROUND_COMPONENT.MODAL_TITLE' | translate"
          [draggable]="false"
          [closable]="true"
          [resizable]="false"
          [modal]="true" [closeOnEscape]="false"
          (onHide)="displayChange.emit(false);this.resetComponent()">
  <div class="grid">
    <div class="col-12">
      <h3>{{'GROUND_COMPONENT.REASON_TITLE' | translate}}</h3>
      <textarea pInputTextarea [(ngModel)]="justification" rows="10"></textarea>
    </div>
    <div class="col-12 center">
      <button pButton type="button" [icon]="'fa fa-check'" [label]="'COMMON.CONFIRM' | translate"
              (click)="emitAcceptation()"
              class="p-button-success"></button>
    </div>
  </div>
</p-dialog>
